<template>
  <div class="fantan-history">
    <Tabs class="fantan-history-tabs" type="card" :animated="false">
      <TabPane :label="result">
        <fantan-fan-history
          :stat="stat"
          :historical-data="rsData"
          :game="game"
          :table-name="tableName"
          :game-code="gameCode"
          :game-id="gameId"
          @get-badge-count="getBadgeCount"
        />
      </TabPane>
      <TabPane :label="oe">
        <fantan-sum-odd-even-history
          :historical-data="oeData"
          :game="game"
          :game-code="gameCode"
          :game-id="gameId"
          :table-name="tableName"
          @get-badge-count="getBadgeCount"
        />
      </TabPane>
      <TabPane :label="history">
        <fantan-history-details
          :historical-data="hData"
          :game="game"
          :game-code="gameCode"
          :game-id="gameId"
          :table-name="tableName"
          @get-badge-count="getBadgeCount"
        />
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import { Tabs, TabPane, Row, Col, Badge, Message } from "iview";
import FantanFanHistory from "./fantan-history/FantanFanHistory";
import FantanHistoryDetails from "./fantan-history/FantanHistoryDetails";
import FantanSumOddEvenHistory from "./fantan-history/FantanSumOddEvenHistory";

export default {
  props: [
    "stat",
    "historicalData",
    "game",
    "gameCode",
    "gameId",
    "gameData",
    "goodroadOn",
    "gameData",
    "drawResult",
    "tableName"
  ],
  components: {
    Tabs,
    TabPane,
    Badge,
    Message,
    FantanFanHistory,
    FantanHistoryDetails,
    FantanSumOddEvenHistory,
  },
  data() {
    return {
      rsData: {},
      hData: {},
      oeData: {},
      result: (h) => {
        return h("div", [h("span", this.$t("fantan.result"))]);
      },
      oe: (h) => {
        return h("div", [h("span", this.$t("fantan.OE"))]);
      },
      history: (h) => {
        return h("div", [h("span", this.$t("fantan.history"))]);
      },
    };
  },
  watch: {
    historicalData() {
      this.rsData = [...this.historicalData];
      this.oeData = [...this.historicalData];
      this.hData = [...this.historicalData];
    },
  },
  methods: {
    getBadgeCount(value) {
      this[value[0]] = (h) => {
        return h("div", [
          h("span", this.$t(value[1])),
          h(Badge, { props: { count: value[2] } }),
        ]);
      };
      if (value[2] > 3) {
        if (this.goodroadOn) this.displayInfoMessage(value);
      }
    },
    displayInfoMessage(arr) {
      Message.info({
        duration: 10,
        top: 10000,
        closable: true,
        render: (h) => {
          return h("span", [
            this.gameData.title,
            " ",
            h("span", { class: arr[4] }, this.changeCode(arr[3])),
            "  x  ",
            arr[2],
          ]);
        },
      });
    },
    changeCode(val) {
      if (val == 1) return this.$t("fantan.odd_trend");
      if (val == 2) return this.$t("fantan.even_trend");
      else return val;
    },
  },
};
</script>

<style lang="scss">
.ivu-icon-ios-information-circle:before {
  display: none !important;
}

.goodRoadIconRed {
  width: 16px;
  height: 16px;
  border-radius: 100px;
  line-height: 15px;
  font-size: 10px;
  font-weight: bold;
  background: #ff5050;
  color: #ffffff;
  text-align: center;
  display: inline-block;
}

.goodRoadIconBlue {
  width: 16px;
  height: 16px;
  border-radius: 100px;
  line-height: 15px;
  font-size: 10px;
  font-weight: bold;
  background: #4ebaf1;
  color: #ffffff;
  text-align: center;
  display: inline-block;
}

.goodRoadIconGrey {
  width: 16px;
  height: 16px;
  border-radius: 100px;
  line-height: 15px;
  font-size: 10px;
  font-weight: bold;
  background: #6f4118;
  color: #ffffff;
  text-align: center;
  display: inline-block;
}

.goodRoadIconYellow {
  width: 16px;
  height: 16px;
  border-radius: 100px;
  line-height: 15px;
  font-size: 10px;
  font-weight: bold;
  background: #ffff99;
  color: black;
  text-align: center;
  display: inline-block;
}

.goodRoadIconGreen {
  width: 16px;
  height: 16px;
  border-radius: 100px;
  line-height: 15px;
  font-size: 10px;
  font-weight: bold;
  background: #228b22;
  color: #ffffff;
  text-align: center;
  display: inline-block;
}

.ivu-tabs-nav-scroll {
  overflow: hidden;
  white-space: nowrap;
  border-bottom: 2px solid #4ebaf1;
}

.fantan-history-tabs.ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab-active {
  border: unset;
  color: #4ebaf1;
}

.ivu-tabs-nav-scroll .ivu-tabs-nav {
  padding: 0 4px;
}

.history-stat-bar {
  background-color: #ffffff;
  padding: 4px 12px;
  margin: 2px;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 600;
  flex: 1 1 auto;
}

.fantan-history-tabs.ivu-tabs.ivu-tabs-card {
  position: unset;
  overflow: unset;
}

.fantan-history-tabs .ivu-tabs-bar {
  border-bottom: unset;
  margin-bottom: unset;
}

.fantan-history-tabs.ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
  border: unset;
  border-radius: unset;
  font-size: 10px;
  padding-bottom: unset;
  font-weight: bold;
  color: $title-font-color-blue;
  position: relative;
  background: transparent;
  height: 31px;
  line-height: 24px;
}

.fantan-history-tabs.ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab:last-of-type {
  margin-right: 0;
}

.fantan-history-tabs.ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-nav-container {
  color: #4ebaf1;
}

.ivu-tabs-tab-active {
  border: unset;
  color: $title-font-color-blue;
  background: #f3f3f3;
}

.fantan-history-tabs.ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab-active:after {
  content: "";
  position: absolute;
  bottom: 5px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 7px solid #4ebaf1;
}

.fantan-history-tabs .ivu-tabs-tabpane {
  padding: 5px;
}

.fantan-history-tabs.ivu-tabs .ivu-tabs-tabpane {
  background-color: $trend-bg;
  min-height: 180px;
}

.fantan-history-tabs.ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab-active {
  border: unset;
  color: $title-font-color-blue;
  background: #f3f3f3;
}
.fantan-history-tabs.ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab-active:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 7px solid #4ebaf1;
}

.ivu-badge-count {
  line-height: 12px !important;
  height: 14px !important;
  width: 12px !important;
  margin-left: 3px !important;
  z-index: 0 !important;
}
</style>